module.exports = __webpack_public_path__ + "static/media/picto-magnify.20d04839.svg";